import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { LeadsService } from 'src/app/business-service/leads/leads.service';
import { GlobalService } from 'src/app/modules/shared/services/global/global.service';
import { LovDataService } from 'src/app/modules/shared/services/lov-data/lov-data.service';
import { ComponentReloadService } from 'src/app/modules/shared/services/reload/component-reload.service';
import { ResponseNotificationService } from 'src/app/modules/shared/services/response-notification/response-notification.service';

@Component({
  selector: 'app-lead-information',
  templateUrl: './lead-information.component.html',
  styleUrls: ['./lead-information.component.scss'],
})
export class LeadInformationComponent  implements OnInit {

  @Input() leadId:any;
  @Input() clientId:any;
  @Input() leadDetails:any;
  @Input() editVisaId: any;
  
  @Output() viewChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() updateLeadServices: EventEmitter<any> = new EventEmitter<any>();
  @Output() storeFormData: EventEmitter<any> = new EventEmitter<any>();

  leadServicesForm!: FormGroup;
  disableServiceType: boolean = false;
  
  travelServices:any;
  assignedUserNameId:any

  constructor(
    private _fb: FormBuilder,
    private _leadService: LeadsService,
    private _lovDataService: LovDataService,
    private _globalService: GlobalService,
    private _responseNotificationService: ResponseNotificationService,
    private _reloadService: ComponentReloadService
  ) { }

  async ngOnInit() {
    if(this.leadDetails){
      this._lovDataService.getUser(this.leadDetails.ownership).subscribe((data)=>{        
        this.assignedUserNameId = `${data.firstName} ${data.lastName} (${data.userId})`
      })
    }
    this.leadServicesForm = this._fb.group({
      leadNote: [""]
    });

    this.leadServicesForm.valueChanges.subscribe(()=>{
      this.leadServicesForm.markAsTouched();
    })
  }

  async onSubmit(){
    if(this.leadServicesForm.valid){
      this.serializeEditFormData(this.leadServicesForm.value).then(formData=>{
        this._leadService.updateLead(this.leadId, formData).subscribe((data)=>{
          this._responseNotificationService.showMessage("Updated lead's services!");
          this._reloadService.triggerLeadsReload();
          this.leadServicesForm.markAsPristine();
          this.storeFormData.emit(data);
        })
      })
    }else{
      this.leadServicesForm.markAllAsTouched();
      this._globalService.scrollToFirstInvalidControl();
      this._globalService.customAlert("Form not valid, select atleast one service!");
    }
  }

  private async serializeEditFormData(formData: any) {
    var serializedData = {...this.leadDetails};
    if(formData.leadNote){
      let tempNote = {
        note: formData.leadNote,
        userId: localStorage.getItem("jti"),
        createDate: this._globalService.getTodaysDateTime()
      }
      if(serializedData.leadNotes){
        serializedData.leadNotes.push(tempNote);
      }else{
        serializedData.leadNotes = [tempNote];
      }
    }    
    return serializedData;
  }

  async resetForm(){
    if(await this._globalService.confirmActionPopup("Confirm to reset data", "Confirm", "Confirm")){
      this.ngOnInit();
    }    
  }

  goPrevious(){
    this.viewChange.emit(true);
  }

  goNext(){
    this.viewChange.emit(false);
  }

  formDataModified(): boolean {
    return (this.leadServicesForm.dirty || this.leadServicesForm.invalid) && this.leadServicesForm.touched;
  }

}
